import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, BACKEND_URL } from "@/lib/api";
import { waLink } from "@/lib/whatsapp";
import WaIcon from "@/components/whatsapp/WaIcon";
import { useSiteContent } from "@/context/SiteContentContext";

const getCfg = () => api.get("/admin/whatsapp/config").then((r) => r.data).catch(() => ({}));

export default function WaSaleButton({ sale }) {
    const [busy, setBusy] = useState(false);
    const { content } = useSiteContent();
    const cur = sale.display_currency === "EUR" ? "EUR" : "LEK";
    const totalLabel = cur === "EUR"
        ? `€${Number(sale.total || 0).toFixed(2)}`
        : `${Math.round(Number(sale.total || 0) * (content.currency_lek_per_eur || 100)).toLocaleString()} Lek`;
    const phone = sale.customer_phone;
    if (!phone) return null;

    const send = async () => {
        setBusy(true);
        const win = window.open("", "_blank");
        const type = sale.doc_type || "preventiv";
        const label = type === "preventiv" ? "Preventivi" : "Fatura";
        try {
            const [{ data }, cfg] = await Promise.all([api.get(`/admin/sales/${sale.id}/share-link`, { params: { type, currency: cur } }), getCfg()]);
            const url = `${BACKEND_URL}${data.path}`;
            const caption = `${label} juaj nga ${sale.customer_name ? "Turbo Cimi për " + sale.customer_name : "Turbo Cimi"} · Totali ${totalLabel}`;
            if (cfg.api_ready || cfg.qr_connected) {
                try {
                    await api.post("/admin/whatsapp/send/document", { phone, url, filename: `${label}-${sale.id.slice(0, 8)}.pdf`, caption });
                    toast.success(`${label} u dërgua në WhatsApp`);
                    win?.close();
                    return;
                } catch (e) {
                    toast.message(e?.response?.data?.detail || "API dështoi – po hapet WhatsApp-i");
                }
            }
            const link = waLink(phone, `${caption}\n${url}`);
            if (win) win.location.href = link;
            else window.open(link, "_blank");
        } catch (e) {
            win?.close();
            toast.error(e?.response?.data?.detail || "Gabim");
        } finally {
            setBusy(false);
        }
    };

    return (
        <button onClick={send} disabled={busy} className="p-1.5 text-[#25D366] hover:scale-110 transition-transform" title="Dërgo në WhatsApp" data-testid={`wa-send-sale-${sale.id}`}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <WaIcon className="w-4 h-4" />}
        </button>
    );
}
